import { Children } from "react";
import { castArray, get, curry } from "lodash/fp"

export const isMdxType = curry((mdxType, child) => castArray(mdxType).includes(get('props.mdxType', child)))

export const filterChildrenByMdxType = (children, mdxType) =>
  Children.toArray(children).filter(isMdxType(mdxType));

export const filterChildrenByNotMdxType = (children, mdxType) =>
  Children.toArray(children).filter(child => !isMdxType(mdxType, child));

export const indexOfChildByMdxType = (children, mdxType) =>
  Children.toArray(children).findIndex(isMdxType(mdxType));

export const splitMdxType = (mdxType, children) => {
  const result = [[]]

  Children.toArray(children).forEach((child) => {
    if (isMdxType(mdxType, child)) {
      result.push([])
    } else {
      result[result.length - 1].push(child)
    }
  })

  return result
}

export const splitOnMdxType = (mdxType, children) => {
  const result = []

  Children.toArray(children).forEach((child) => {
    if (isMdxType(mdxType, child) || !result.length) {
      result.push([])
    }

    result[result.length - 1].push(child)
  })

  return result
}

export const getIllustration = (children) => {
  const childrenArray = Children.toArray(children)
  const illustrationIndex = childrenArray.findIndex(isMdxType('img'))

  return {
    illustration: childrenArray[illustrationIndex],
    content: childrenArray.filter((_, i) => i !== illustrationIndex)
  }
}
